const style = { height: "100%", borderRadius: 8 };
const mapStyle = "mapbox://styles/mapbox/satellite-streets-v12";
const onRender = (event) => event.target.resize(); // fixes map being wrong size on load
const standardMapProps = { style, mapStyle, onRender };

export const defaultZoom = 15;

export default standardMapProps;
